var React = require('react');

function TickCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8,0C3.6,0,0,3.6,0,8c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8C16,3.6,12.4,0,8,0z M11.6,5.5l-3.3,5.9c-0.1,0.2-0.4,0.4-0.6,0.4\n\tc0,0-0.1,0-0.1,0c-0.2,0-0.4-0.1-0.6-0.3L4.5,8.5C4.2,8.2,4.2,7.7,4.6,7.4c0.3-0.3,0.8-0.2,1.1,0.1l1.8,2.1l2.8-4.9\n\tc0.2-0.4,0.7-0.5,1.1-0.3C11.7,4.6,11.8,5.1,11.6,5.5z"}));
}

TickCircle.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = TickCircle;

TickCircle.default = TickCircle;
